import React from 'react';
import {classes, style} from './doppe-action-type-property-widget.st.css';
import {DoppeActionTypeProperty} from '../doppe-action-type-property';
import {DoppeActionGoalType, DoppeActionType} from '../../../client-server-common/doppe-action-types/doppe-action-type';
import {
    DoppeActionTypeWidgetInnerDescription
} from '../../../components/doppe-action-type-widget-inner-description/doppe-action-type-widget-inner-description';
import {IDoppeViewerActionContext} from '../../../doppe-sdk';
import {
    DoppeActionTypeWidgetInnerTitle
} from '../../../components/doppe-action-type-widget-inner-title/doppe-action-type-widget-inner-title';
import {
    DoppeActionTypeWidgetLayout
} from '../../../components/doppe-action-type-widget-layout/doppe-action-type-widget-layout';
import {
    DoppeActionTypePriceDataView
} from '../../../components/doppe-action-type-price-data-view/doppe-action-type-price-data-view';
import {
    DoppeActionTypeWidgetContentLayoutWrapper2
} from '../../../components/doppe-action-type-widget-content-layout-wrapper-2/doppe-action-type-widget-content-layout-wrapper-2';

export const DoppeActionTypePropertyWidget = React.memo(function DoppeActionTypePropertyWidget(
    props: DoppeActionType.WidgetProps<DoppeActionTypeProperty.ActionSettings>
) {
    const {
        actionContext,

        className,
        ...htmlAttributes
    } = props;

    return (
        <DoppeActionTypeWidgetLayout
            {...htmlAttributes}
            className={style(classes.root, {}, className)}
            actionContext={actionContext}
        >
            <DoppeActionTypePropertyWidgetInner
                actionContext={actionContext}
                reportGoalAchieved={(goalType) => {
                    actionContext.reportGoalAchieved({
                        goalType: goalType,
                    })
                }}
                actionId={actionContext.action.id}
                actionSettings={actionContext.action.settings}
            />
        </DoppeActionTypeWidgetLayout>
    );
});


export const DoppeActionTypePropertyWidgetInner = React.memo(function DoppeActionTypePropertyWidgetInner(
    props: {
        actionSettings: DoppeActionTypeProperty.ActionSettings;
        reportGoalAchieved: (goalType: DoppeActionGoalType) => void;
        actionId: string;
        actionContext: IDoppeViewerActionContext;
        listItemId?: string;
    }
) {
    const {
        actionSettings,
        reportGoalAchieved,
        actionContext,
        listItemId
    } = props;


    const {
        propertyName,
        priceData,
        description,
        address,
        media,
        mainMediaViewSettings,
        mainMediaViewLayout
    } = actionSettings;

    return (
        <>
            <DoppeActionTypeWidgetContentLayoutWrapper2
                sections={actionSettings.sections}
                buttons={actionSettings.ctaButtons}
                actionContext={actionContext}
                reportGoalAchieved={reportGoalAchieved}
                mainMediaViewLayout={mainMediaViewLayout}
                mainMediaViewSettings={mainMediaViewSettings}
                media={media}
                buttonsSettings={{
                    listItemId: listItemId,
                }}
            >
                <DoppeActionTypeWidgetInnerTitle>
                    {propertyName}
                </DoppeActionTypeWidgetInnerTitle>
                <DoppeActionTypeWidgetInnerDescription
                >
                    {description}
                </DoppeActionTypeWidgetInnerDescription>
                <DoppeActionTypeWidgetInnerDescription
                >
                    {address}
                </DoppeActionTypeWidgetInnerDescription>
                <DoppeActionTypePriceDataView
                    className={style(classes.price, {})}
                    priceData={priceData}
                />

            </DoppeActionTypeWidgetContentLayoutWrapper2>
        </>
    );
});






